module.exports = __webpack_public_path__ + "img/article7.70b2e09d.png";